import { ReactElement } from 'react';
import ReactDOM from 'react-dom';

export default function render(node: ReactElement<unknown>, element: HTMLElement) {
  ReactDOM.render(node, element);

  return function unmount() {
    ReactDOM.unmountComponentAtNode(element);
  };
}
